import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className={`text-xl md:text-2xl font-bold font-heading ${
              scrolled || !isHome ? 'text-primary-500' : 'text-background-50'
            }`}>
              韩漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-500' : 'text-background-50') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/langman"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname === '/about' ? (scrolled || !isHome ? 'text-primary-500' : 'text-background-50') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
            } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link
              to="/"
              className={`py-2 px-3 rounded-lg text-sm font-medium ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <button
              onClick={() => setCategoryOpen(!categoryOpen)}
              className="py-2 px-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 flex items-center justify-between cursor-pointer"
            >
              分类
              <i className={`text-sm transition-transform ${categoryOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
            </button>
            {categoryOpen && (
              <div className="pl-4 flex flex-col gap-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="py-2 px-3 rounded-lg text-sm text-foreground-600 hover:bg-background-100 flex items-center gap-2 cursor-pointer"
                  >
                    <i className={`${cat.icon} text-base`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
            <Link
              to="/about"
              className={`py-2 px-3 rounded-lg text-sm font-medium ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}